import React from 'react';

interface Props {
  text: string;
  color: string;
  className?: string;
  iconLeft?: any;
  size?: string;
}


const PlainBadge: React.FC<Props> = (props: Props) => {

  let iconSize = 14;
  let cls = "rounded-full px-2 text-center flex items-center ";
  if (props.color === "gray") {
    cls += "bg-gray-400 border-gray-1000 text-gray-1000 ";
  } else if (props.color === "green") {
    cls += "bg-aquamarine-500 border-aquamarine-1000 text-aquamarine-1000 ";
  } else if (props.color === "orange") {
    cls += "bg-orange-500 border-orange-1000 text-orange-1000 ";
  } else if (props.color === "red") {
    cls += "bg-cherry-500 border-cherry-1000 text-cherry-1000 ";
  } else if (props.color === "primary") {
    cls += "bg-primary-600 border-primary-1000 text-primary-1000 ";
  }
  if (props.size === "small") {
    iconSize = 12;
  } else {
    cls += "py-1 "
  }
  if (props.className) {
    cls += props.className
  }

  return (
    <div className={cls}>
      {
        props.iconLeft &&
          <img src={props.iconLeft} style={{width: iconSize, height: iconSize, marginRight: 4}} alt="icon"/>
      }
      <p className="text-xs">{props.text}</p>
    </div>
  )
}

export default PlainBadge;